import React from 'react';
import { prop } from 'ramda';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import { ApiOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ElementsRoutes from '../elements/Routes';
import MenuLayout from '../../components/MenuLayout';
import { Setting } from '../../components/icons';
import Elements from '../elements/Elements';
import MyTeam from './components/MyTeam';
import TeamApiKey from './components/TeamApiKey';

const menuItems = [
  {
    label: 'Utilisateurs',
    icon: <UsergroupAddOutlined className="mr-3" />,
    path: '/utilisateurs'
  },
  {
    label: 'Paramétrage',
    icon: <Setting className="mr-3 " />,
    path: '/parametrage'
  },
  {
    label: 'Clé API',
    icon: <ApiOutlined className="mr-3" />,
    path: '/cle-api'
  }
];

const Team = ({ match }) => {
  const matchUrl = prop('url', match);
  return (
    <MenuLayout title="Mon équipe" menuItems={menuItems}>
      <Switch>
        <Route exact path={matchUrl}>
          <Redirect to={`${matchUrl}/utilisateurs`} />
        </Route>
        <Route path={`${matchUrl}/utilisateurs`} component={MyTeam} />
        <Route path={`${matchUrl}/parametrage`} component={Elements} />
        <Route path={`${matchUrl}/cle-api`} component={TeamApiKey} />
        <ElementsRoutes match={match} />
      </Switch>
    </MenuLayout>
  );
};

export default withRouter(Team);
